import React from 'react';
import { PasswordReset } from './ResetPassword';
import { SecurityQuestion } from './SecurityQuestion';

var Security = function Security(_ref) {
  var prefix = _ref.prefix,
      userData = _ref.userData,
      userPreferencesCallback = _ref.userPreferencesCallback,
      securityChildrenNode = _ref.securityChildrenNode,
      trans = _ref.trans;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PasswordReset, {
    prefix: prefix,
    title: 'SFxUserPreferencesPasswordTitle',
    subtitle: 'SFxUserPreferencesPasswordSubtitle',
    userPreferencesCallback: userPreferencesCallback,
    trans: trans
  }), /*#__PURE__*/React.createElement(SecurityQuestion, {
    prefix: prefix,
    title: 'SFxUserPreferencesSecurityQuestionTitle',
    subtitle: 'SFxUserPreferencesSecurityQuestionSubtitle',
    userPreferencesCallback: userPreferencesCallback,
    userId: userData.userId,
    trans: trans
  }), securityChildrenNode);
};

export default Security;